import { LayoutElement, isLayoutTableFieldElement } from "@entaconsulting/form";
import { Stack } from "@mui/material";
import EntaAccordion from "common/components/EntaAccordion";
import { PanelSections } from "developer/edit/constants";
import useDynamicField from "developer/edit/hooks/useDynamicField";
import useIsExpanded from "developer/edit/hooks/useIsExpanded";
import React from "react";
import TableColumnsListForm from "./TableColumnsListForm";

const TableColumnsSection: React.FC<{}> = (props) => {
  const { isExpanded, handleChangeIsExpanded } = useIsExpanded(
    PanelSections.TableColumns
  );
  const {
    input: { value: element },
  } = useDynamicField<LayoutElement>("element");

  if (!isLayoutTableFieldElement(element)) return null;

  const defaultExpanded = element.listFields.fields.length > 0;

  return (
    <EntaAccordion
      title="Table Columns"
      expanded={isExpanded}
      onChange={handleChangeIsExpanded}
      defaultExpanded={defaultExpanded}
    >
      <Stack spacing={1}>
        <TableColumnsListForm />
      </Stack>
    </EntaAccordion>
  );
};

export default TableColumnsSection;
